import {
  FormControlLabel,
  FormHelperText,
  FormLabel,
  Radio,
  styled,
} from "@mui/material";

export const StyledLabelSpan = styled("span")(({ theme }) => ({
  color: theme.palette.custom.danger,
}));
export const StyledFormLabel = styled(FormLabel)(({ theme }) => ({
  color: theme.palette.custom.productTextColor,
  fontSize: theme.typography.regular.fontSize,
  marginTop: "24px",
  fontWeight: theme.typography.fontWeight.medium,
  "&.Mui-focused": {
    color: theme.palette.custom.productTextColor,
  },
}));
export const StyledFormControlLabel = styled(FormControlLabel)(({ theme }) => ({
  color: theme.palette.custom.lockerValueColor,
}));
export const StyledFormHelperText = styled(FormHelperText)(({ theme }) => ({
  color: theme.palette.custom.danger,
  margin: "0px",
}));
export const StyledRadio = styled(Radio)(({ theme }) => ({
  color: theme.palette.custom.radioBgColor,
  "&.Mui-checked": {
    color: theme.palette.custom.radioBgColor,
  },
  "& .MuiSvgIcon-root": {
    fontSize: theme.typography.regular.fontSize,
    backgroundColor: theme.palette.custom.radioBg,
    borderRadius: "50%",
    width: "18px",
    height: "18px",
    border: "none",
  },
  "&.Mui-checked .MuiSvgIcon-root": {
    border: "1px solid red",
  },
}));
